import { FunctionComponent } from "react";

import { faTriangleExclamation } from "@fortawesome/pro-regular-svg-icons";

import { Button } from "@/components/Button/Button";
import { ButtonColor, ButtonSize } from "@/components/Button/types";
import { Icon } from "@/components/Icon/Icon";

interface CrmReconnectBannerProps {
	title: string;
	description: string;
	buttonLabel: string;
	isLoading?: boolean;
	onReconnect: () => void;
}

/**
 * "Reconnect required" for a CRM whose stored sign-in the CRM refuses (PREC-4353). Nothing syncs
 * until the company signs in again, and a new sign-in keeps the settings and field mappings, so
 * the banner offers exactly that instead of Disconnect.
 */
export const CrmReconnectBanner: FunctionComponent<CrmReconnectBannerProps> = ({
	title,
	description,
	buttonLabel,
	isLoading = false,
	onReconnect,
}) => (
	<div
		className="flex items-center gap-3 p-4 mb-4 rounded-lg border border-status-warning bg-status-warning-light"
		data-testid="crm-reconnect-banner"
		role="alert"
	>
		<Icon className="w-5 h-5 text-status-warning" icon={faTriangleExclamation} />
		<div className="flex flex-1 flex-col">
			<span className="text-sm font-semibold text-status-warning">{title}</span>
			<span className="text-xs text-gray-600">{description}</span>
		</div>
		<Button
			color={ButtonColor.ACTION}
			isLoading={isLoading}
			size={ButtonSize.S}
			title={buttonLabel}
			onClick={onReconnect}
		/>
	</div>
);
